module.exports = __webpack_public_path__ + "static/clive-moore-cannab-agency-headshot-4e0651c08c6665d70d18543e4d366270.jpg";